var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#05DB4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.875 8.34317C19.369 6.83194 17.429 6.04393 15.2936 6H9.93338C6.62708 6.04393 4 8.69577 4 12.0094C4 15.3231 6.68658 18.0189 9.98895 18.0189H15.2931C17.5019 18.0189 19.2427 16.2159 19.2427 13.9994C19.2427 11.783 17.4458 9.98 15.2369 9.98H9.8256L9.04085 13.0047H15.2369C15.7837 13.0047 16.2283 13.4508 16.2283 13.9994C16.2283 14.5481 15.7837 14.9942 15.2369 14.9942H9.93282C8.29258 14.9942 7.0144 13.6553 7.0144 12.0094C7.0144 10.3636 8.28977 9.05119 9.93282 9.02471H15.2903C18.024 9.02471 20.1925 11.2564 20.1925 14C20.1925 16.7436 17.9684 18.9753 15.2341 18.9753H7.93051L7.14576 22H15.2936C17.4172 21.9594 19.369 21.1681 20.875 19.6568C22.3811 18.1456 23.2102 16.137 23.2102 14C23.2102 11.863 22.3811 9.8544 20.875 8.34317Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ee610e12fa8859cb9c6efac7e79108bc.svg";
export { ForwardRef as ReactComponent };